import type { LeaveType } from "./leaveCalendar.types";
import {
  FIXED_LEAVE_TYPE_CODES,
  normalizeLeaveTypeCode,
  type FixedLeaveTypeCode,
} from "./leaveCalendar.constants";

const BUSINESS_TRIP_LEAVE = "business trip leave";
const REMOTE_WORK = "remote work";

function isFixedLeaveTypeCode(code: string): code is FixedLeaveTypeCode {
  const n = normalizeLeaveTypeCode(code);
  return FIXED_LEAVE_TYPE_CODES.some((c) => normalizeLeaveTypeCode(c) === n);
}

/**
 * Map stored `leaveType` string to calendar colour / letter bucket.
 * Known backend codes (FIXED_LEAVE_TYPE_CODES): `business trip leave` → business_trip (K),
 * `remote work` → remote_work (R), all others → vacation (V).
 * Legacy DB values fall back with light heuristics.
 */
export function leaveTypeCodeToVisual(code: string): LeaveType {
  const n = normalizeLeaveTypeCode(code);

  if (n === normalizeLeaveTypeCode(BUSINESS_TRIP_LEAVE)) {
    return "business_trip";
  }

  if (n === normalizeLeaveTypeCode(REMOTE_WORK)) {
    return "remote_work";
  }

  if (isFixedLeaveTypeCode(code)) {
    return "vacation";
  }

  const u = String(code || "").toUpperCase();
  if (/SICK|MEDICAL|LIGA|ILL/.test(u)) {
    return "vacation";
  }
  if (/BUSINESS|TRIP|BT|KOMANDIR|TRAVEL/.test(u)) {
    return "business_trip";
  }

  return "vacation";
}
